export function MobileMenuIcon({ className }: { className?: string }) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            fill="none"
            viewBox="0 0 20 20"
            focusable="false"
            aria-hidden="true"
            className={className}
        >
            <path
                stroke="currentColor"
                strokeLinecap="square"
                strokeLinejoin="round"
                d="M1 13h18M1 7h18"
            ></path>
        </svg>
    )
}
